import { Provider } from "react-redux";
import RouterData from "./Routes";
import { ToastContainer } from "react-toastify";
import Store from "./ReduxToolkit/Store";
import { parseJwt, setAxiosConfig, setToken } from "./utils";
import axios from "axios";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "./ReduxToolkit/Hooks";
import { setUser } from "./ReduxToolkit/Reducers/UserSlice";
import { useNavigate } from "react-router-dom";
import { getOwnStatsAction } from "./Api/auth";

setAxiosConfig(axios, Store);
const token = localStorage.getItem("token")

const App = () => {
  const dispatch = useAppDispatch()
  const loggedIn = useAppSelector(state => state.user.loggedIn)

  const getUserStats = async () => {
    try {
      const response = await getOwnStatsAction();
      if (response.status === 'success') {
        dispatch(setUser({
          pages_count: response.payload.pages_count,
          videos_count: response.payload.videos_count,
          total_views: response.payload.total_views
        }))
      }

    } catch (error) {
    }
  }

  useEffect(() => {
    if (!token) return
    const user = parseJwt(token)
    setToken(token || "")
    dispatch(setUser(user))
  }, [dispatch])

  useEffect(() => {
    if (!loggedIn) return
    getUserStats()
  }, [loggedIn])

  return (
    <>
      <Provider store={Store} >
        <RouterData />
        <ToastContainer />
      </Provider>
    </>
  );
};

export default App;
